var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTable)?_c('el-table',{attrs:{"data":_vm.scoreList,"border":"","header-row-style":_vm.tableHeaderStyle,"header-cell-style":_vm.tableHeaderStyle,"cell-style":_vm.cellStyle,"span-method":_vm.arraySpanMethod,"empty-text":"ไม่พบข้อมูล"}},[_c('el-table-column',{attrs:{"type":"index","label":"ลำดับ","header-align":"center","align":"center","sortable":"","index":function (index) { return index+1},"width":_vm.widthMax < 767.98 ? '78' : _vm.widthMax < 991 ? '60' : '78'}}),_c('el-table-column',{attrs:{"prop":"name","label":"หัวข้อแบประเมินออนไลน์","header-align":"center","sortable":"","width":_vm.widthMax < 767.98
        ? '150'
        : _vm.widthMax < 1150
        ? ''
        : _vm.widthMax > 1199.98
        ? ''
        : ''}}),_c('el-table-column',{attrs:{"prop":"avg","label":"คะแนนประเมินเฉลี่ย","header-align":"center","align":"center","width":_vm.widthMax < 767.98
        ? '120'
        : _vm.widthMax < 1150
        ? '120'
        : _vm.widthMax > 1199.98
        ? '300'
        : '120',"sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.avg ? scope.row.avg.toFixed(1) : 0)+" คะแนน")]}}],null,false,917046853)}),_c('el-table-column',{attrs:{"prop":"updatedAt","label":"วันที่และเวลาที่อัปเดต","header-align":"center","align":"center","width":_vm.widthMax < 767.98
        ? '120'
        : _vm.widthMax < 991
        ? '130'
        : _vm.widthMax < 1150
        ? '200'
        : _vm.widthMax > 1199.98
        ? '250'
        : ''},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm._f("dateTimeTh")(scope.row.updatedAt)))]}}],null,false,1005727513)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }